import { ChangeDetectionStrategy, Component } from "@angular/core";

import {
  ITab,
  TabNavigationComponent,
  TabNavigationStateService,
  tabNavigationStateServiceInjectionToken
} from "@zaeper/angular-dashboard-view-lib";
import { InstalledAppsTabComponent } from "./tabs/installed-apps-tab/installed-apps-tab.component";
import { StoreAppsTabComponent } from "./tabs/store-apps-tab/store-apps-tab.component";

@Component({
  selector: 'app-available-apps-modal',
  templateUrl: './available-apps-overview-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TabNavigationComponent,
    InstalledAppsTabComponent,
    StoreAppsTabComponent
],
  providers: [
    {
      provide: tabNavigationStateServiceInjectionToken,
      useClass: TabNavigationStateService
    }
  ]
})
export class AvailableAppsOverviewModalComponent {
  public tabs: ITab[] = [
    {
      title: "Gekauft",
      subject: "purchased"
    },
    {
      title: "Store",
      subject: "store"
    }
  ]
}
